import { render, staticRenderFns } from "./CockpitTextComponent.vue?vue&type=template&id=490c4054&scoped=true"
import script from "./CockpitTextComponent.vue?vue&type=script&lang=js"
export * from "./CockpitTextComponent.vue?vue&type=script&lang=js"
import style0 from "./CockpitTextComponent.vue?vue&type=style&index=0&id=490c4054&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490c4054",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('490c4054')) {
      api.createRecord('490c4054', component.options)
    } else {
      api.reload('490c4054', component.options)
    }
    module.hot.accept("./CockpitTextComponent.vue?vue&type=template&id=490c4054&scoped=true", function () {
      api.rerender('490c4054', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/entries/cockpitFormCompontents/CockpitTextComponent.vue"
export default component.exports